import { render } from "./WarehouseDatatableTDDocumentTitle.vue?vue&type=template&id=255ada8c"
import script from "./WarehouseDatatableTDDocumentTitle.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableTDDocumentTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__